/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_syl_haiku_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free haiku syllable counter. Check that your poem follows the 5-7-5 syllable pattern, line by line, as you write. No signup.`)
};

const es_syl_haiku_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de sílabas para haiku gratuito. Comprueba, línea por línea y mientras escribes, que tu poema sigue el patrón de sílabas 5-7-5. Sin registro.`)
};

const de_syl_haiku_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Haiku-Silbenzähler. Prüfe während des Schreibens Zeile für Zeile, ob dein Gedicht dem 5-7-5-Silbenmuster folgt. Keine Anmeldung nötig.`)
};

const nl_syl_haiku_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis haiku-lettergreepteller. Controleer of je gedicht het 5-7-5 lettergreeppatroon volgt, regel voor regel, terwijl je schrijft. Geen registratie nodig.`)
};

const fr_syl_haiku_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compteur de syllabes pour haïku gratuit. Vérifiez ligne par ligne, au fil de l'écriture, que votre poème respecte le schéma de syllabes 5-7-5. Sans inscription.`)
};

const it_syl_haiku_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contatore di sillabe per haiku gratuito. Verifica che la tua poesia segua lo schema di sillabe 5-7-5, riga per riga, mentre scrivi. Nessuna registrazione.`)
};

const pt_br2_syl_haiku_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de sílabas para haiku gratuito. Verifique se seu poema segue o padrão silábico 5-7-5, linha por linha, enquanto você escreve. Sem cadastro.`)
};

const pt_syl_haiku_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de sílabas para haiku gratuito. Verifique se o seu poema segue o padrão silábico 5-7-5, linha a linha, à medida que escreve. Sem registo.`)
};

const ja_syl_haiku_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の俳句音節カウンター。入力しながら、詩が5-7-5の音節パターンに従っているかを行ごとに確認できます。登録不要。`)
};

const zh_syl_haiku_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的俳句音节计数器。边写边逐行检测你的诗是否符合5-7-5音节格式，无需注册。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const syl_haiku_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.syl_haiku_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("syl_haiku_meta_description", locale)
	if (locale === "en") return en_syl_haiku_meta_description(inputs)
	if (locale === "es") return es_syl_haiku_meta_description(inputs)
	if (locale === "de") return de_syl_haiku_meta_description(inputs)
	if (locale === "nl") return nl_syl_haiku_meta_description(inputs)
	if (locale === "fr") return fr_syl_haiku_meta_description(inputs)
	if (locale === "it") return it_syl_haiku_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_syl_haiku_meta_description(inputs)
	if (locale === "pt") return pt_syl_haiku_meta_description(inputs)
	if (locale === "ja") return ja_syl_haiku_meta_description(inputs)
	return zh_syl_haiku_meta_description(inputs)
};